import React from 'react'
import { useSelector } from 'react-redux'
import { selectActiveMapEvents } from '../../../store/map/map.selectors'
import cross from '../../genericComponents/assets/cross.svg'
import SVGIcon from '../../svg/SVGIcon'
import useEventCallback from '../../utils/useEventCallback'
import useNotificationHelper, { checkEachWeek } from '../../utils/useNotificationHelper'
import s from './MapEventTooltip.less'

export const MAP_EVENTS_TOOLTIP_NOTIFICATION_KEY = 'mapEventTooltip'

const MapEventTooltip = () => {
  const activeMapEvents = useSelector(selectActiveMapEvents)
  const { notificationActive, disableNotification } = useNotificationHelper(
    MAP_EVENTS_TOOLTIP_NOTIFICATION_KEY,
    checkEachWeek
  )

  const onClose = useEventCallback(() => {
    disableNotification()
  }, [disableNotification])

  if (!activeMapEvents.length || !notificationActive) return <></>

  const { key, tooltipLabel } = activeMapEvents[0]

  return (
    <div className={s.root}>
      <div className={s.content}>
        <p key={key}>{tooltipLabel}</p>
      </div>
      <div className={s.closeIcon} onClick={onClose}>
        <SVGIcon url={cross} />
      </div>
      <div className={s.arrow}></div>
    </div>
  )
}
export default MapEventTooltip
